import { getAnalyticsServiceVariation } from '@/helpers/getAnalyticsServiceVariation'
import { apiRoutes } from 'lib/@getethos/urls/apiRoutes'

export const sendToAnalyticsService = (
  event: string,
  properties: Record<string, any>,
  callback?: any
) => {
  const { isControl, isHybrid, isService } = getAnalyticsServiceVariation()

  if (isControl) {
    return
  }

  apiRoutes.sendAnalyticsEvent({
    event: event,
    properties: properties,
  })

  if (callback) {
    callback()
  }
}
